// removed by extract-text-webpack-plugin
module.exports = {"login":"src-components-Login-Login__login--3tsO6"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Login/Login.scss
// module id = 552
// module chunks = 1